
import { defineComponent, ref, reactive, watch, nextTick, onMounted, onBeforeUnmount, getCurrentInstance } from 'vue'
import { mapState, useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'

import Swiper from 'swiper/swiper-bundle'
import 'swiper/swiper-bundle.min.css'

import COVERAPP from '@/utils/COVERAPP'
// import speakersData from '@/utils/speakersData'

export default defineComponent({
    setup (props, context) {
        const $store = useStore()
        const isShow = ref<boolean>(true)
        const $router = useRouter()
        const list = $store.state.activityData.templateConfig.speakersData
        let lecturerSiwper: any = null
        const startAni = ref<boolean>(true)

        const initSwiper = () => {
            lecturerSiwper = new Swiper('.slide-wrapper .swiper', {
                slidesPerView: 'auto',
                updateOnWindowResize: true,
                loop: true,
                on: {
                    slideChangeTransitionStart () {
                        startAni.value = false
                    }
                },
            })
        }

        const prev = () => {
            startAni.value = false
            lecturerSiwper.slidePrev()
        }

        const next = () => {
            startAni.value = false
            lecturerSiwper.slideNext()
        }

        const toggle = () => {
            startAni.value = false
            isShow.value = !isShow.value
        }

        const goSpeaker = (index) => {
            const url = `/speakers/${index}`
            if (!COVERAPP.Attribute.isMb()) {
                const href = $router.resolve({
                    path: url,
                }).href
                window.open(href)
            } else {
                $router.push(url)
            }
        }

        onBeforeUnmount(() => {
            lecturerSiwper.destroy()
        })

        onMounted(() => {
            initSwiper()
        })    

        return {
            isShow,
            list,
            startAni,
            prev,
            next,
            toggle,
            goSpeaker
        }
    }
})
